import { ProductRangeEnum, ProductTypeEnum } from '../../../../legacy/shared-types';
import { IProductDataTransformed } from 'queries/products/useProductsList/types';
import { ALL_FILTER_OPTION } from '../types';

export const formatMaxFTVOptions = (productList: IProductDataTransformed[]) => {
  const maximumFTVSorted = productList.map(product => product.maximumFTV).sort((a, b) => b - a);
  const uniqueFTVOptions = [ALL_FILTER_OPTION, ...new Set(maximumFTVSorted)];
  const uniqueFTVOptionsFormatted = uniqueFTVOptions.map(item => ({
    label: typeof item === 'string' ? item : `${(item * 100).toFixed(2)}%`,
    value: item.toString(),
  }));

  return uniqueFTVOptionsFormatted;
};

export const defaultSelectOptionFormatter = (item: string) => ({
  label: item,
  value: item,
});

export const formatProductTypeFilterOptions = (productTypeFilterOptions: ProductTypeEnum[]) => {
  const productTypeOptions = [ALL_FILTER_OPTION, ...productTypeFilterOptions];
  return productTypeOptions.map(defaultSelectOptionFormatter);
};

export const formatProductRangeFilterOptions = (productRangeFilterOptions: ProductRangeEnum[]) => {
  const productRangeOptionsOptions = [ALL_FILTER_OPTION, ...productRangeFilterOptions];
  return productRangeOptionsOptions.map(defaultSelectOptionFormatter);
};

export const formatProductCategoryFilterOptions = (productCategoryFilterOptions: string[]) => {
  const productCategoryOptions = [ALL_FILTER_OPTION, ...productCategoryFilterOptions];
  return productCategoryOptions.map(defaultSelectOptionFormatter);
};
